














import {Component, Prop, Vue} from 'vue-property-decorator'
import {SelectOption} from "@/util/selectOption";

type NavOption = {
    title: string;
    href: string;
}

@Component
export default class TaxReturnNav extends Vue {

    @Prop()
    year!: number;

    @Prop({
        default: []
    })
    employerLinks!: SelectOption[]

    // Remember that this needs to match with the nav order in the Tax controllers
    private navOptions: NavOption[] = [];

    private initialValue: NavOption | null = null;

    private mounted() {
        this.navOptions = [
            {
                title: 'Basic details',
                href: 'basic-details'
            },
            {
                title: 'Vehicle details',
                href: 'vehicles'
            },
            {
                title: 'Marriage allowance',
                href: 'marriage-allowance'
            },
            {
                title: 'Employment',
                href: 'employment'
            }
        ];

        for (const employer of this.employerLinks) {
            this.navOptions.push({
                title: `Employment - ${employer.name}`,
                href: `employment/${employer.id}`
            });
        }

        this.navOptions.push(
            {
                title: 'Pension',
                href: 'pension'
            },
            {
                title: 'Benefits',
                href: 'benefits'
            },
            {
                title: 'Other details',
                href: 'other'
            },
            {
                title: 'Review & submit',
                href: 'review'
            }
        );

        const pathname = window.location.pathname;
        let href = '';
        if (pathname.includes('employment/')) {
            href = pathname.substring(
                pathname.indexOf('employment/')
            );
        } else {
            const pathParts = pathname.split('/');
            href = (pathParts.pop() || pathParts.pop()) || ''; // handle potential trailing slash
        }
        this.initialValue = this.navOptions.find(navOption => navOption.href === href)!;
    }

    private optionUpdated(newOption: NavOption) {
        window.location.href = `/tax-return/${this.year}/${newOption.href}`;
    }
}
